import React from 'react'
import ImageEditor from 'react-avatar-editor'
import styled from 'styled-components'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css';

const HiddenFileInput = styled.input.attrs({
  accept: 'image/*',
  type: 'file',
})`
  display: none;
`

const readFileAsDataUrl = file => new Promise(resolve => {
  const reader = new FileReader()

  reader.onload = event => {
    resolve(event.target.result)
  }
  reader.readAsDataURL(file)
})


class ImageLoader extends React.Component {
  constructor (props) {
    super(props)

    const { label, url } = this.props
    const storedUrl = window.localStorage.getItem(`${label}.url`)
    const storedZoom = window.localStorage.getItem(`${label}.zoom`)
    const storedPosition = JSON.parse(window.localStorage.getItem(`${label}.position`))

    this.state = {
      fullImageUrl: storedUrl || url,
      zoom: (storedZoom && parseFloat(storedZoom)) || 100,
      position: storedPosition,
    }
  }
/*
  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      fullImageUrl: nextProps.url,
    })
  }
*/
  editor = React.createRef()

  handleChange = async event => {
    const zoom = 100
    const position = { x: 0.5, y: 0.5 }
    const { label } = this.props

    window.localStorage.setItem(`${label}.zoom`, String(zoom))
    window.localStorage.setItem(`${label}.position`, JSON.stringify(position))

    const fullImageUrl = await readFileAsDataUrl(event.target.files[0])
    window.localStorage.setItem(`${this.props.label}.url`, fullImageUrl)

    this.setState({
      fullImageUrl: fullImageUrl,
      zoom,
      position,
    })
  }

  async handleImageChange(userInteraction) {
    const { onChange } = this.props
    const ref = this.editor.current
    
    try {
      const canvas = await ref.getImage()
      if (ref && onChange) {
        onChange(canvas, userInteraction)
      }
    } catch(e) {
      console.error(e)
    }
  }

  handleImageChangeWithInteraction = this.handleImageChange.bind(this, true)
  handleImageChangeWithoutInteraction = this.handleImageChange.bind(this, false)

  handleZoomChange = (zoom) => {
    window.localStorage.setItem(`${this.props.label}.zoom`, zoom)
    this.setState({ zoom })
  }

  handlePositionChange = position => {
    window.localStorage.setItem(`${this.props.label}.position`, JSON.stringify(position))
    this.setState({ position })
  }


  render () {
    const {
      label,
      imageWidth,
      imageHeight,
    } = this.props;

    const id = `ImageLoader-${this.props.id}`;
    const { fullImageUrl } = this.state
    const zoom = parseInt(this.state.zoom, 10);

    return (
      <div className="text-center">
        <ImageEditor
          image={fullImageUrl}
          width={imageWidth}
          height={imageHeight}
          border={[20, 20]}
          position={this.state.position}
          scale={this.state.zoom / 100}
          ref={this.editor}
          onImageReady={this.handleImageChangeWithoutInteraction}
          onImageChange={this.handleImageChangeWithInteraction}
          onPositionChange={this.handlePositionChange}
        />

        <HiddenFileInput
          id={id}
          onChange={this.handleChange}
        />
        <label htmlFor={id} className="d-block">
          <span className="btn btn-torquise btn-block"
          >
            Add Your {label}
          </span>
        </label>
        <div>
          Zoom {this.state.zoom}%
          <div className="d-flex align-items-center justi-content-between">
            <button onClick={() => this.handleZoomChange(zoom - 1)} className="btn btn-secondary mr-1">-</button>
            <Slider
              min={5}
              max={200}
              step={1}
              value={zoom}
              onChange={this.handleZoomChange}
            />
            <button onClick={() => this.handleZoomChange(zoom + 1)} className="btn btn-secondary ml-1">+</button>
          </div>
        </div>
      </div>
    )
  }
}

export default ImageLoader



// WEBPACK FOOTER //
// ./src/components/ImageLoader.js